export const InitialValuesProfileAccount = {
  profilePicture: "",
  gender: "",
  lastname: "",
  firstname: "",
  email: "",
  phone: "",
};